import { render, staticRenderFns } from "./Shortcut.vue?vue&type=template&id=6a02f806&scoped=true"
import script from "./Shortcut.vue?vue&type=script&lang=js"
export * from "./Shortcut.vue?vue&type=script&lang=js"
import style0 from "./Shortcut.vue?vue&type=style&index=0&id=6a02f806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02f806",
  null
  
)

export default component.exports